import { getRequirementId, isRequirementRef } from '../../../../../util/namedLocationRequirement.util'

// Unlike a group requirement, a named location requirement's requirementId is an opaque generated
// key, not its name — the name lives on the matching definition. This builds a
// { "location:<requirementId>": name } lookup for every such value found, so a review screen can
// show the name instead of the raw sentinel/id.
const buildNamedLocationRequirementOptionsMap = (values = [], definitions = []) =>
  Object.fromEntries(
    values
      .filter(isRequirementRef)
      .map((value) => [
        value,
        definitions.find((definition) => definition.requirementId === getRequirementId(value))?.name,
      ]),
  )

export default buildNamedLocationRequirementOptionsMap
